import {
  ADMIN_ALERT,
  REMOVE_ADMIN_ALERT
} from "../_actions/adminAlertActionCreator"

const initAlert = {
  id: "",
  type: "",
  message: "",
  consumer: ""
}

const adminAlert = (state = initAlert, action) => {
  switch (action.type) {
    case ADMIN_ALERT: {
      return { ...action.payload, id: action.id }
    }
    case REMOVE_ADMIN_ALERT: {
      if (action.id) {
        if (state.id === action.id) {
          return { ...initAlert }
        } else {
          return { ...state }
        }
      } else {
        return { ...initAlert }
      }
    }
    default:
      return { ...state }
  }
}

export default adminAlert
